module.exports = require("memoizee");


//////////////////
// WEBPACK FOOTER
// external "memoizee"
// module id = 525
// module chunks = 0